import { Link } from "react-router-dom";
import React from "react";
import ApiConfig from "../common/config/ApiConfig";
import "./lotteryselect.css";
import { motion } from "framer-motion";
import moment from "moment";
import LoadingComponent from "./LoadingComponent"; // Replace with the correct path
import AllOutIcon from "@mui/icons-material/AllOut";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// getLottoTypeSchedule reports open/closed directly via `status` — no
// separate time-window check needed.
function isLottoOpen(item) {
  return !!(item && item.status);
}

// The close time shown on a card comes from whichever round is currently
// open (round.status === true); round_date[0].end_time is already an
// "HH:mm" string.
function getActiveRoundEndTime(item) {
  const openRound = item?.rounds?.find((round) => round.status);
  return openRound?.round_date?.[0]?.end_time;
}

// The type is already known to be open, so the close time ("HH:mm") is
// assumed to still be ahead today; no day-of-week/month evaluation needed.
function getCountdown(endTime, now) {
  if (!endTime) return null;
  const [hours, minutes] = endTime.split(":").map(Number);
  const target = moment(now).set({
    hours,
    minutes,
    seconds: 0,
    milliseconds: 0,
  });
  const duration = moment.duration(Math.max(target.diff(now), 0));
  const hh = String(Math.floor(duration.asHours())).padStart(2, "0");
  const mm = String(duration.minutes()).padStart(2, "0");
  const ss = String(duration.seconds()).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}

function LottoCard({
  to,
  state,
  logoSrc,
  logoIcon,
  title,
  isOpen,
  closeTime,
  countdown,
  description,
}) {
  const { t } = useTranslation();
  const cardBody = (
    <div
      className={
        isOpen
          ? "flex flex-col h-[172px] rounded-card overflow-hidden bg-gradient-to-br from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 shadow-cardLight hover:shadow-card hover:-translate-y-1 transition-all duration-200 border-2 border-brand-gold-300"
          : "flex flex-col h-[172px] rounded-card overflow-hidden bg-white shadow-sm border border-slate-200 opacity-60"
      }
    >
      <div
        className={
          isOpen
            ? "flex flex-row items-center justify-between px-3 py-2 bg-gradient-to-r from-brand-blue-600 to-brand-blue-800"
            : "flex flex-row items-center justify-between px-3 py-2 bg-slate-400"
        }
      >
        <span className="text-brand-gold-200 font-bold font-heading text-sm">
          {title}
        </span>
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={title}
            className="w-6 h-6 rounded-full bg-white p-0.5"
          />
        ) : (
          <span className="w-6 h-6 rounded-full bg-white flex items-center justify-center">
            {logoIcon}
          </span>
        )}
      </div>

      <div className="flex-1 flex flex-col justify-center gap-2 p-3">
        {isOpen && description && (
          <div className="text-white/70 text-xs">{description}</div>
        )}

        {closeTime !== undefined && (
          <div
            className={
              isOpen
                ? "flex items-center gap-1 text-white/70 text-xs"
                : "flex items-center gap-1 text-slate-500 text-xs"
            }
          >
            <AccessTimeIcon fontSize="inherit" />
            <span>
              {t("lotterySelect.closeAt")} {closeTime || "-"}
            </span>
          </div>
        )}

        <div
          className={
            isOpen
              ? "flex items-center justify-center gap-1 bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-full py-1.5 font-bold text-sm"
              : "flex items-center justify-center gap-1 bg-slate-100 text-slate-500 border border-slate-200 rounded-full py-1.5 font-bold text-sm"
          }
        >
          {isOpen ? (
            <>
              <CheckCircleIcon fontSize="small" />
              {t("lotterySelect.open")}
            </>
          ) : (
            <>
              <DoNotDisturbIcon fontSize="small" />
              {t("lotterySelect.closed")}
            </>
          )}
        </div>

        {isOpen && countdown && (
          <div className="flex items-center justify-center gap-1 text-brand-gold-300 text-xs font-semibold">
            <HourglassBottomIcon
              fontSize="inherit"
              className="animate-hourglass-spin"
            />
            <span>
              {t("lotterySelect.timeRemaining")} {countdown}
            </span>
          </div>
        )}
      </div>
    </div>
  );

  return isOpen ? (
    <Link to={to} state={state} className="block">
      {cardBody}
    </Link>
  ) : (
    <div>{cardBody}</div>
  );
}

function Lotteryselect(props) {
  const { t } = useTranslation();
  const [lottoTypes, setLottoTypes] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [now, setNow] = useState(new Date());
  const user = localStorage.getItem("user");

  const OrderGet = () => {
    const json = {
      memberuser: user,
    };
    ApiConfig.post("/getLottoTypeSchedule", json).then((res) => {
      if (res.resCode === 200) {
        setLottoTypes(res.data);
      }
    });
  };

  //#region all status

  const getLottoType = (type) => lottoTypes.find((item) => item.type === type);

  const th_gov = getLottoType("th_gov");
  const laos_gov = getLottoType("laos_gov");
  const hanoi = getLottoType("hanoy_PhuQua");
  const yeekee_5 = getLottoType("Yeekee_5");
  const yeekee_10 = getLottoType("Yeekee_10");
  const yeekee_15 = getLottoType("Yeekee_15");

  //#endregion

  useEffect(() => {
    OrderGet();
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="w-[100%] h-[40px] p-2 bg-gradient-to-r from-brand-blue-800 via-brand-blue-700 to-brand-blue-800 border-b-2 border-brand-gold-300 rounded-t-lg shadow-card">
        <span className="text-brand-gold-200 font-bold font-heading text-m">
          {t("lotterySelect.sectionTitle")}
        </span>
      </div>

      {loading ? (
        <LoadingComponent />
      ) : (
        <div className="bg-brand-blue-900 border-[1px] border-brand-gold-300/30 w-[100%] h-[auto] drop-shadow-2xl">
          <div className="flex flex-col flex-wrap bg-gradient-to-br from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 p-3 w-[100%] h-[auto] shadow-inner">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="grid grid-cols-1 sm:grid-cols-3 gap-3"
            >
              <LottoCard
                to="/dashboard/thgov"
                state={{ id: th_gov?.id }}
                logoSrc="/images/th_gov.jpg"
                title={t("lotterySelect.types.thGov")}
                isOpen={isLottoOpen(th_gov)}
                closeTime={getActiveRoundEndTime(th_gov)}
                countdown={getCountdown(getActiveRoundEndTime(th_gov), now)}
              />

              <LottoCard
                to="/dashboard/laosgov"
                state={{ id: laos_gov?.id }}
                logoSrc="/images/laoslogo.png"
                title={t("lotterySelect.types.laosGov")}
                isOpen={isLottoOpen(laos_gov)}
                closeTime={getActiveRoundEndTime(laos_gov)}
                countdown={getCountdown(getActiveRoundEndTime(laos_gov), now)}
              />

              <LottoCard
                to="/dashboard/hanoi"
                state={{ id: hanoi?.id }}
                logoSrc="/images/hanoilogo.png"
                title={t("lotterySelect.types.hanoi")}
                isOpen={isLottoOpen(hanoi)}
                closeTime={getActiveRoundEndTime(hanoi)}
                countdown={getCountdown(getActiveRoundEndTime(hanoi), now)}
              />
            </motion.div>
          </div>
        </div>
      )}

      <div className="w-[100%] h-[40px] mt-2 p-2 bg-gradient-to-r from-brand-blue-800 via-brand-blue-700 to-brand-blue-800 border-b-2 border-brand-gold-300 rounded-t-lg shadow-card">
        <span className="text-brand-gold-200 font-bold font-heading text-m">
          {t("lotterySelect.yeekeeSectionTitle")}
        </span>
      </div>

      {loading ? (
        <LoadingComponent />
      ) : (
        <div className="bg-brand-blue-900 border-[1px] border-brand-gold-300/30 w-[100%] h-[auto] drop-shadow-2xl">
          <div className="flex flex-col flex-wrap bg-gradient-to-br from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 p-3 w-[100%] h-[auto] shadow-inner">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="grid grid-cols-1 sm:grid-cols-3 gap-3"
            >
              <LottoCard
                to="/dashboard/Yeekee_5"
                state={{ id: yeekee_5?.id }}
                logoIcon={
                  <AllOutIcon
                    className="spin text-brand-gold-500"
                    fontSize="small"
                  />
                }
                title={t("lotterySelect.types.yeekeeNormal")}
                isOpen={isLottoOpen(yeekee_5)}
                description={t("lotterySelect.yeekeeDescription.normal")}
              />

              <LottoCard
                to="/dashboard/Yeekee_10"
                state={{ id: yeekee_10?.id }}
                logoIcon={
                  <AllOutIcon
                    className="spin text-brand-gold-500"
                    fontSize="small"
                  />
                }
                title={t("lotterySelect.types.yeekeeVip")}
                isOpen={isLottoOpen(yeekee_10)}
                description={t("lotterySelect.yeekeeDescription.vip")}
              />

              <LottoCard
                to="/dashboard/Yeekee_15"
                state={{ id: yeekee_15?.id }}
                logoIcon={
                  <AllOutIcon
                    className="spin text-brand-gold-500"
                    fontSize="small"
                  />
                }
                title={t("lotterySelect.types.yeekeeVvip")}
                isOpen={isLottoOpen(yeekee_15)}
                description={t("lotterySelect.yeekeeDescription.vvip")}
              />
            </motion.div>
          </div>
        </div>
      )}
    </>
  );
}

export default Lotteryselect;
